import { atom, useRecoilTransaction_UNSTABLE } from 'recoil';

import { UpsertParentOrganisationRequest } from 'api';
import { Organisation } from 'types';

export const organisationRequestState = atom<UpsertParentOrganisationRequest | undefined>({
  key: 'organisationRequest',
  default: undefined,
});

export const organisationIdState = atom<number | undefined>({
  key: 'organisationId',
  default: undefined,
});

export const organisationState = atom<Organisation | undefined>({
  key: 'organisation',
  default: undefined,
});

export const organisationCreatedState = atom<Organisation | undefined>({
  key: 'organisationCreated',
  default: undefined,
});

export const useResetOrganisationState = (): (() => void) =>
  useRecoilTransaction_UNSTABLE(({ reset }) => () => {
    reset(organisationRequestState);
    reset(organisationIdState);
    reset(organisationState);
  });
